import { Button } from '@mui/material';
import FormProvider from 'src/components/hook-form';
import { useNavigate, useParams } from 'react-router';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import { endpoints } from 'src/utils/axios';
import { getRequest } from 'src/services';
import Iconify from 'src/components/iconify';
import { Card, CardContent, Typography, Grid, Divider, Pagination } from '@mui/material';
import { useEffect, useState } from 'react';
import { useProfileContext } from 'src/components/profile/context';
import { useBoolean } from 'src/hooks/use-boolean';
import ViewPayStub from './genrate-payroll-view-paystub';
import PayrollDeductionsAccordion from './genrate-payroll-create-deduction';
import { formatCurrency } from '../../risk-register/feching';
import { LoadingScreen } from 'src/components/loading-screen';
import { deductionCategories } from './payroll-data';
import { HoursTableView } from './genrate-payroll-create-hour-view';
import { LoadingButton } from '@mui/lab';

const GeneratePayrollViewPage = () => {
  const navigate = useNavigate();
  const { userProfile } = useProfileContext();
  const { id } = useParams();
  const add = useBoolean();
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(1);
  const [payroll, setPayroll] = useState({});
  console.log('🚀 ~ GeneratePayrollViewPage ~ payroll:', payroll);
  const [employeeData, setEmployeeData] = useState([]);
  console.log('🚀 ~ GeneratePayrollViewPage ~ employeeData:', employeeData);
  const [loading, setLoading] = useState(false);

  const netPay = employeeData.reduce((total, employee) => {
    const taxDetails = employee.payroll_tax_details?.[0] || {};
    const netPay = parseFloat(taxDetails.net_pay || 0);
    return netPay;
  }, 0);
  console.log('🚀 ~ netPay ~ netPay:', netPay);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const payrollData = [
    { header: 'Name Of Contractor / SubContractor', value: userProfile?.company_name || '' },
    { header: 'Payroll Number', value: payroll?.payroll_number || '' },
    { header: 'Address', value: userProfile?.address || userProfile?.city || '' },
    { header: 'For Week Endings', value: payroll?.week_ending_date || '' },
  ];
  const paginatedEmployees = employeeData.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const defaultValues = {};
  const NewUserSchema = Yup.object().shape({});
  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  useEffect(() => {
    getEmployeeViewDetails();
  }, [id]);

  const getEmployeeViewDetails = async () => {
    setLoading(true);
    try {
      const response = await getRequest(
        `${endpoints.accounting.payroll.generate_payroll.emoployee_view}/${id}`
      );
      if (!response) throw new Error('No data');
      const payroll = response.payroll || {};
      const employees = response.employee_time_sheets || [];
      const employeesWithRates = employees.map((emp) => {
        const entries = emp.time_sheet.weekly_time_sheet.flatMap((d) => d.entries);
        const firstEntry = entries[0] || {};
        const regular_time_rate = firstEntry.trade_worker_title?.regular_time_rate ?? 0;
        const over_time_rate = firstEntry.trade_worker_title?.over_time_rate ?? 0;
        const standardHours = emp.time_sheet.grand_total_hours;
        let overtimeHours = 0;
        entries.forEach((e) => {
          if ((e.total_time_hours || 0) > 8) {
            overtimeHours += e.total_time_hours - 8;
          }
        });
        const adjustedStandard = standardHours - overtimeHours;
        const raw = emp.payroll_tax_details?.[0] || {};
        const deductions = {
          federalIncomeTax: parseFloat(raw.federal_income_tax) || 0,
          ssEmployee: parseFloat(raw.social_security_employee) || 0,
          medicareEmployee: parseFloat(raw.medicare_employee) || 0,
          medicareEmployer: parseFloat(raw.medicare_employer) || 0,
          additionalMedicareTax: parseFloat(raw.medicare_employee) || 0,
          stateIncomeTax: parseFloat(raw.state_income_tax) || 0,
          stateDisabilityInsurance: 0,
          stateEmployeeUnemploymentInsurance: parseFloat(raw.state_unemployment_tax) || 0,
          localIncomeTax: parseFloat(raw.local_income_tax) || 0,
          commuterTaxes: 0,
          ssEmployer: parseFloat(raw.social_security_employer) || 0,
          medicareEmpemloyer: parseFloat(raw.medicare_employer) || 0,
          federalUnploymentTax: parseFloat(raw.futa_tax) || 0,
          // stateUnemploymentTax: parseFloat(raw.state_unemployment_tax_rate) || 0,
          stateUnemploymentTax: 0,
          stateDisabilityFamilyLeave: 0,
          otherStateMandatedLeave: 0,
          localPayrollTaxes: 0,
          workersCompensation: 0,
          employerHealthCareMandatePenalties: 0,
          preTaxDeductions: parseFloat(raw.pre_tax_deductions) || 0,
          retirementPlan: parseFloat(emp.retirement_contributions) || 0,
          healthInsurance: parseFloat(emp.health_insurance) || 0,
          healthSavingsAccount: parseFloat(emp.health_saving_account) || 0,
          qualifiedTransportation: parseFloat(emp.qualified_transportation) || 0,
          groupLifeInsurance: parseFloat(emp.group_life_insurance) || 0,
          miscOthers: parseFloat(emp.other_deductions) || 0,
          roth401k: parseFloat(emp.roth_401_k),
          additionalInsurance: parseFloat(emp.additional_insurance) || 0,
          unionDues: parseFloat(emp.union_dues) || 0,
          charitableContributions: parseFloat(emp.charitable_contributions) || 0,
          loanRepayments: parseFloat(emp.loan_repayments) || 0,
        };

        return {
          ...emp,
          regular_time_rate,
          over_time_rate,
          overtimeHours,
          standardHours: adjustedStandard,
          deductions,
        };
      });

      setPayroll(payroll);
      setEmployeeData(employeesWithRates);
    } catch (err) {
      console.error(err);
      setEmployeeData([]);
    } finally {
      setLoading(false);
    }
  };

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleNavigate = () => {
    navigate('/accounts-management/payroll/genrate-payroll');
  };
  const onSubmit = handleSubmit(async (data) => {});
  return (
    <div style={{ marginLeft: '14px' }}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
          }}
        >
          <h2>Generate Payroll</h2>
          <Button
            onClick={handleNavigate}
            className="dark-button"
            variant="contained"
            startIcon={<Iconify icon="material-symbols:arrow-back" />}
          >
            Back
          </Button>
        </div>
        <Card sx={{ mb: 3, mx: 2 }}>
          <CardContent sx={{ bgcolor: '#919EAB14' }}>
            <Grid container spacing={2}>
              {payrollData.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box sx={{ display: 'flex', mb: 1 }}>
                    <Typography variant="subtitle2" sx={{ width: '50%', color: 'text.secondary' }}>
                      {item.header}
                    </Typography>
                    <Typography variant="body2" sx={{ width: '50%' }}>
                      {item.value}
                    </Typography>
                  </Box>
                  <Divider sx={{ my: 1.5 }} />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
        {loading ? (
          <Box height={700}>
            <LoadingScreen />
          </Box>
        ) : (
          <>
            {paginatedEmployees.length > 0 ? (
              paginatedEmployees.map((employee) => (
                <Card key={employee.id} sx={{ mb: 3, mx: 2 }}>
                  <CardContent>
                    <Grid container spacing={2} sx={{ bgcolor: '#919EAB14' }} mb={2} mt={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', mb: 1 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ width: '50%', color: 'text.secondary' }}
                          >
                            Employee Name
                          </Typography>
                          <Typography variant="body2" sx={{ width: '50%' }}>
                            {employee.first_name || ''} {employee.last_name}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', mb: 1 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ width: '50%', color: 'text.secondary' }}
                          >
                            Gross Amount Earned
                          </Typography>
                          <Typography variant="body2" sx={{ width: '50%' }}>
                            {formatCurrency(
                              employee.standardHours * employee.regular_time_rate +
                                employee.overtimeHours * employee.over_time_rate
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', mb: 1 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ width: '50%', color: 'text.secondary' }}
                          >
                            Net Weekly Paid Wage
                          </Typography>
                          <Typography variant="body2" sx={{ width: '50%' }}>
                            {formatCurrency(netPay)}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3,
                      }}
                    >
                      <Typography variant="h6"></Typography>
                      <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                          onClick={add.onTrue}
                          variant="contained"
                          size="small"
                          className="dark-button"
                          startIcon={<Iconify icon="solar:eye-bold" />}
                        >
                          View Paystub
                        </Button>
                        <LoadingButton
                          onClick={() =>
                            navigate(`/accounts-management/payroll/genrate-payroll/issue/${id}`, {
                              state: { employeeId: employee?.id },
                            })
                          }
                          className="dark-button"
                          variant="contained"
                          size="small"
                          startIcon={<Iconify icon="material-symbols:payments" />}
                          disabled={payroll.status?.name?.toLowerCase() !== 'approved'}
                          sx={{
                            mx: 2,
                            opacity: payroll.status?.name?.toLowerCase() !== 'approved' ? 0.6 : 1,
                            pointerEvents:
                              payroll.status?.name?.toLowerCase() !== 'approved' ? 'none' : 'auto',
                            cursor:
                              payroll.status?.name?.toLowerCase() !== 'approved'
                                ? 'not-allowed'
                                : 'pointer',
                          }}
                        >
                          Issue payment
                        </LoadingButton>
                      </Box>
                    </Box>
                    <Grid container spacing={4}>
                      <HoursTableView
                        employeeData={employee}
                        overtime={{
                          totalHours: employee.overtimeHours,
                          payRate: employee.over_time_rate || 0,
                        }}
                        standard={{
                          totalHours: employee.standardHours,
                          payRate: employee.regular_time_rate,
                        }}
                      />
                    </Grid>
                    <Divider sx={{ my: 3 }} />
                    <Grid item xs={12}>
                      <Card variant="outlined" sx={{ bgcolor: '#fafafa' }}>
                        <CardContent>
                          <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
                            DEDUCTIONS
                          </Typography>
                          <PayrollDeductionsAccordion
                            deductionCategories={deductionCategories}
                            deductions={employee.deductions}
                            editing={false}
                            handleChange={() => {}}
                            EditableCell={() => null}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  </CardContent>
                </Card>
              ))
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography>No employee data available</Typography>
              </Box>
            )}
          </>
        )}
        {employeeData.length > 0 && (
          <ViewPayStub
            open={add.value}
            onClose={add.onFalse}
            payrollData={payroll}
            employeeTimeSheets={employeeData}
          />
        )}
        {employeeData.length > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
            <Pagination
              count={Math.ceil(employeeData.length / rowsPerPage)}
              page={page}
              onChange={handleChangePage}
              shape="rounded"
              color="primary"
            />
          </Box>
        )}
      </FormProvider>
    </div>
  );
};
export default GeneratePayrollViewPage;
